export const formatHandicap = (handicapValue = 0, withSeparator = true): string => {
  if (!handicapValue) {
    return "";
  }
  const formattedHandicap = `${handicapValue > 0 ? "+" : ""}${handicapValue}`;

  return withSeparator ? `(${formattedHandicap})` : `${formattedHandicap}`;
};

export type FormatRunnerNameOptions = {
  handicap?: number;
  handicapWithSeparator?: boolean;
  runnerNumber?: string;
  runnerNumberSeparator?: string;
};

export const formatRunnerName = (name: string, options: FormatRunnerNameOptions = {}): string => {
  const { handicap = 0, handicapWithSeparator = true, runnerNumber, runnerNumberSeparator = " " } = options;

  const prefixed = runnerNumber ? `${runnerNumber}${runnerNumberSeparator}${name}` : name;

  if (!handicap) {
    return prefixed;
  }

  return `${prefixed} ${formatHandicap(handicap, handicapWithSeparator)}`;
};

/**
 * formatHorseInfo
 * @param runnerInfo
 * Transforms uppercase string to lowercase except for the first character of every word "\b\w"
 * and the characters between parenthesis "\(.+?\)"
 *
 * Example
 * input: ELEVATED CITY (USA)
 * output: Elevated City (USA)
 */
export const formatHorseInfo = (runnerInfo: string | undefined): string | undefined =>
  runnerInfo?.toLowerCase().replace(/(\b\w|\(.+?\))/g, (m) => m.toUpperCase());
